"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Trigger = _interopRequireDefault(require("./Trigger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// based on rc-trigger 2.6.5
var _default = _Trigger.default;
exports.default = _default;